'use strict';

(function () {
  if (window.__sbInit) return;
  window.__sbInit = true;

  /* ---- analytics ---- */
  window.sbTrack = (function () {
    function dl() {
      window.dataLayer = window.dataLayer || [];
      return window.dataLayer;
    }

    function lang() {
      return document.documentElement.dataset.lang === 'en' ? 'en' : 'zh';
    }

    function getCookie(name) {
      var m = document.cookie.match(
        '(?:^|;\\s*)' +
          name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') +
          '=([^;]*)',
      );
      if (!m) return '';
      try {
        return decodeURIComponent(m[1]);
      } catch (e) {
        return '';
      }
    }

    var COOKIE_DOMAIN = 'sweetbites.my';
    var COOKIE_DOMAIN_RE = new RegExp(
      '(^|\\.)' + COOKIE_DOMAIN.replace(/\./g, '\\.') + '$',
    );

    function domainAttr() {
      return COOKIE_DOMAIN_RE.test(location.hostname)
        ? '; domain=.' + COOKIE_DOMAIN
        : '';
    }

    function setCookie(name, value, maxAgeSeconds) {
      document.cookie =
        name +
        '=' +
        encodeURIComponent(value) +
        '; path=/' +
        domainAttr() +
        '; max-age=' +
        (maxAgeSeconds || 3600) +
        '; SameSite=Lax; Secure';
    }

    function clientId() {
      var parts = getCookie('_ga').split('.');
      return parts.length < 4 ? '' : parts.slice(-2).join('.');
    }

    var GA4_STREAM = '';

    function sessionId() {
      var m = document.cookie.match(
        GA4_STREAM
          ? new RegExp(
              '(?:^|;\\s*)_ga_' + GA4_STREAM.replace(/^G-/, '') + '=([^;]*)',
            )
          : /(?:^|;\s*)_ga_[A-Z0-9]+=([^;]*)/,
      );
      if (!m) return '';
      var s = m[1].match(/^GS\d\.\d\.s?(\d+)/);
      return s ? s[1] : '';
    }

    var FB_MAX_AGE = 7776000;
    var TIKTOK_CLICK_MAX_AGE = 2592000;
    var META_ATTR_FIELDS = [
      { param: 'utm_source', key: 'source', cookie: 'sb_meta_source' },
      {
        param: 'utm_campaign',
        key: 'campaignName',
        cookie: 'sb_meta_campaign',
      },
      { param: 'utm_term', key: 'adsetName', cookie: 'sb_meta_adset' },
      { param: 'utm_content', key: 'adName', cookie: 'sb_meta_ad' },
      { param: 'placement', key: 'placement', cookie: 'sb_meta_placement' },
    ];

    function metaValue(value) {
      value = String(value == null ? '' : value).trim();
      return Array.from
        ? Array.from(value).slice(0, 300).join('')
        : value.slice(0, 300);
    }

    function storedMetaAttribution() {
      var out = {};
      META_ATTR_FIELDS.forEach(function (field) {
        var value = getCookie(field.cookie);
        if (value) out[field.key] = value;
      });
      return out;
    }

    function metaAttributionFromUrl() {
      var params;
      try {
        params = new URLSearchParams(location.search);
      } catch (e) {
        return null;
      }

      var out = {};
      META_ATTR_FIELDS.forEach(function (field) {
        var value = metaValue(params.get(field.param));
        if (value) out[field.key] = value;
      });
      if (!Object.keys(out).length) return null;

      var medium = metaValue(params.get('utm_medium')).toLowerCase();
      var source = String(out.source || '').toLowerCase();
      var knownMetaSource = /^(fb|facebook|ig|instagram|msg|messenger|an|audience_network)$/.test(
        source,
      );
      if (
        !params.get('fbclid') &&
        medium !== 'paid_social' &&
        !knownMetaSource
      ) {
        return null;
      }
      return out;
    }

    function metaAttribution() {
      var incoming = metaAttributionFromUrl();
      if (!incoming) return storedMetaAttribution();

      META_ATTR_FIELDS.forEach(function (field) {
        var value = incoming[field.key];
        if (value) setCookie(field.cookie, value, FB_MAX_AGE);
      });
      return Object.assign(storedMetaAttribution(), incoming);
    }

    function fbp() {
      var v = getCookie('_fbp');
      if (v) return v;
      v = 'fb.1.' + Date.now() + '.' + Math.floor(Math.random() * 1e10);
      setCookie('_fbp', v, FB_MAX_AGE);
      return v;
    }

    function fbc() {
      var m = location.search.match(/[?&]fbclid=([^&]*)/);
      if (m && m[1]) {
        var id = m[1];
        try {
          id = decodeURIComponent(m[1]);
        } catch (e) {}
        var v = 'fb.1.' + Date.now() + '.' + id;
        setCookie('_fbc', v, FB_MAX_AGE);
        return v;
      }
      return getCookie('_fbc');
    }

    function ttclid() {
      var m = location.search.match(/[?&]ttclid=([^&]*)/);
      if (m && m[1]) {
        var id = m[1];
        try {
          id = decodeURIComponent(m[1]);
        } catch (e) {}
        setCookie('ttclid', id, TIKTOK_CLICK_MAX_AGE);
        return id;
      }
      return getCookie('ttclid');
    }

    function ttp() {
      return getCookie('_ttp');
    }

    function eventId() {
      if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
      }
      return (
        'sb-' +
        Date.now().toString(36) +
        '-' +
        Math.random().toString(36).slice(2, 10)
      );
    }

    var PAGE_EID = eventId();

    function pageEventId() {
      return PAGE_EID;
    }

    var PLAN_NAMES = {
      trial: 'Trial Pack',
      classic: 'Classic Set',
      monthly: 'Monthly Plan',
    };

    function planItem(card) {
      if (!card) return null;
      var plan = card.getAttribute('data-plan');
      if (!plan || !PLAN_NAMES[plan]) return null;
      return {
        item_id: card.getAttribute('data-variant') || plan,
        item_name: PLAN_NAMES[plan],
        item_category: 'plan',
        price: Number(card.getAttribute('data-price')) || 0,
        quantity: 1,
      };
    }

    function planItems() {
      return [].slice
        .call(document.querySelectorAll('.pcard[data-plan]'))
        .map(planItem)
        .filter(Boolean);
    }

    function push(name, params) {
      var payload = {};
      if (params) {
        for (var k in params) {
          if (Object.prototype.hasOwnProperty.call(params, k)) {
            payload[k] = params[k];
          }
        }
      }
      payload.event = name;
      payload.content_language = lang();
      if (!payload.event_id) payload.event_id = eventId();
      if (payload.ecommerce) dl().push({ ecommerce: null });
      dl().push(payload);
      return payload;
    }

    return {
      push: push,
      planItem: planItem,
      planItems: planItems,
      lang: lang,
      clientId: clientId,
      sessionId: sessionId,
      eventId: eventId,
      pageEventId: pageEventId,
      fbp: fbp,
      fbc: fbc,
      ttclid: ttclid,
      ttp: ttp,
      metaAttribution: metaAttribution,
      getCookie: getCookie,
      setCookie: setCookie,
    };
  })();

  /* ---- line icons ---- */
  var ICONS = {
    leaf: '<path d="M5 19C5 11 11 5 19 5C19 13 13 19 5 19Z"/><path d="M5 19C8 14 12 11 16 9"/>',
    snow: '<path d="M12 3v18M5 7l14 10M19 7L5 17"/><path d="M9 4l3 2 3-2M9 20l3-2 3 2"/>',
    bottle:
      '<path d="M10 3h4v3l1.5 2.5V20a1 1 0 01-1 1h-5a1 1 0 01-1-1V8.5L10 6V3z"/><path d="M8.5 13h7"/>',
    bowl: '<path d="M4 11h16a8 8 0 01-16 0z"/><path d="M9 7c0-1 1-1.5 1-2.5M13 7c0-1 1-1.5 1-2.5"/>',
    truck:
      '<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
    heart:
      '<path d="M12 20S4 14.5 4 9a4 4 0 018-1 4 4 0 018 1c0 5.5-8 11-8 11z"/>',
    clock: '<circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/>',
    check: '<path d="M5 12l4 4 10-10"/>',
  };
  function svg(name) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      ICONS[name] +
      '</svg>'
    );
  }

  /* ---- language ---- */
  var LANG = localStorage.getItem('sb_lang') || 'zh';
  var refreshHeaderLayout = function () {};

  function applyLang() {
    document.documentElement.lang = LANG === 'en' ? 'en' : 'zh-CN';
    document.documentElement.dataset.lang = LANG === 'en' ? 'en' : 'zh';

    var src = document.getElementById('p-flavor-src');
    document.querySelectorAll('[data-en]').forEach(function (el) {
      if (src && src.contains(el)) return;

      if (
        el.namespaceURI === 'http://www.w3.org/2000/svg' &&
        el.tagName.toLowerCase() === 'text'
      ) {
        var tp = el.querySelector('textPath');
        if (tp) {
          if (el.dataset.zh == null) el.dataset.zh = tp.textContent || '';
          tp.textContent = LANG === 'en' ? el.dataset.en : el.dataset.zh;
        }
        return;
      }
      if (el.dataset.zh == null) el.dataset.zh = el.innerHTML;
      var html = LANG === 'en' ? el.dataset.en : el.dataset.zh;
      el.innerHTML = html.replace(/__dot__/g, '<span class="dot">•</span>');
    });
    document.querySelectorAll('.faq-item.open').forEach(function (item) {
      var a = item.querySelector('.faq-a');
      if (a) a.style.maxHeight = a.scrollHeight + 'px';
    });
    var lz = document.getElementById('lang-zh'),
      le = document.getElementById('lang-en'),
      lzm = document.getElementById('lang-zh-m'),
      lem = document.getElementById('lang-en-m');
    if (lz) lz.classList.toggle('on', LANG === 'zh');
    if (le) le.classList.toggle('on', LANG === 'en');
    if (lzm) lzm.classList.toggle('on', LANG === 'zh');
    if (lem) lem.classList.toggle('on', LANG === 'en');
    refreshHeaderLayout();
  }
  function setLang(l) {
    LANG = l;
    localStorage.setItem('sb_lang', l);
    applyLang();
    document.dispatchEvent(
      new CustomEvent('sb:lang-changed', { detail: { lang: l } }),
    );
  }

  /* ---- storefront tracking ---- */
  function trackHomepage() {
    var T = window.sbTrack;
    if (!T) return;

    var cards = [].slice.call(document.querySelectorAll('.pcard[data-plan]'));
    if (!cards.length) return;

    var byPlan = {};
    cards.forEach(function (card) {
      byPlan[card.getAttribute('data-plan')] = card;
    });

    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-select-plan]') : null;
      if (!el) return;
      var item = T.planItem(byPlan[el.getAttribute('data-select-plan')]);
      if (!item) return;
      T.push('select_item', {
        ecommerce: {
          item_list_name: el.getAttribute('data-select-list') || 'pricing',
          items: [item],
        },
      });
    });
  }

  function seedAdCookies() {
    var T = window.sbTrack;
    if (!T) return;
    try {
      T.fbp();
      T.fbc();
      T.ttclid();
      T.metaAttribution();
    } catch (e) {}
  }

  /* ---- init ---- */
  function init() {
    document.querySelectorAll('[data-i]').forEach(function (el) {
      var n = el.dataset.i;
      if (ICONS[n]) el.insertAdjacentHTML('afterbegin', svg(n));
    });

    document.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        var a = item.querySelector('.faq-a');
        var open = item.classList.toggle('open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
      });
    });

    var lz = document.getElementById('lang-zh'),
      le = document.getElementById('lang-en'),
      lzm = document.getElementById('lang-zh-m'),
      lem = document.getElementById('lang-en-m');
    if (lz)
      lz.addEventListener('click', function () {
        setLang('zh');
      });
    if (le)
      le.addEventListener('click', function () {
        setLang('en');
      });
    if (lzm)
      lzm.addEventListener('click', function () {
        setLang('zh');
      });
    if (lem)
      lem.addEventListener('click', function () {
        setLang('en');
      });

    /* ---- header scroll state (sec-header) ---- */
    var secHeader = document.querySelector('.sec.header');
    if (secHeader) {
      var announceBar = secHeader.querySelector('.sb-announce');
      var headbar = secHeader.querySelector('.sb-headbar');
      var barH = 0;
      var scrolled = false;
      var ticking = false;

      document.body.classList.add('sb-has-header');
      document.body.classList.toggle('sb-has-announce', !!announceBar);

      refreshHeaderLayout = function () {
        barH = announceBar
          ? Math.ceil(announceBar.getBoundingClientRect().height)
          : 0;
        var headbarH = headbar
          ? Math.ceil(headbar.getBoundingClientRect().height)
          : 0;
        var offsetH = barH + headbarH;
        var rootStyle = document.documentElement.style;

        secHeader.style.setProperty('--announce-h', barH + 'px');
        secHeader.style.setProperty('--sb-announce-h', barH + 'px');
        rootStyle.setProperty('--sb-announce-h', barH + 'px');
        rootStyle.setProperty('--sb-headbar-h', headbarH + 'px');
        rootStyle.setProperty('--sb-header-offset', offsetH + 'px');
      };

      var update = function () {
        var y = window.scrollY;
        var hideAt = barH || 8;
        if (!scrolled && y > hideAt) {
          scrolled = true;
          secHeader.classList.add('scrolled');
        } else if (scrolled && y < 5) {
          scrolled = false;
          secHeader.classList.remove('scrolled');
        }
        ticking = false;
      };

      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
          }
        },
        { passive: true },
      );
      window.addEventListener('resize', function () {
        refreshHeaderLayout();
        update();
      });
      if ('ResizeObserver' in window) {
        var headerObserver = new ResizeObserver(function () {
          refreshHeaderLayout();
          update();
        });
        if (announceBar) headerObserver.observe(announceBar);
        if (headbar) headerObserver.observe(headbar);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          refreshHeaderLayout();
          update();
        });
      }
      refreshHeaderLayout();
      update();
    }

    /* ---- mobile drawer ---- */
    var drawer = document.getElementById('sb-drawer');
    var burger = document.getElementById('sb-burger');
    if (drawer && burger) {
      var closeDrawer = function () {
        drawer.classList.remove('open');
      };
      burger.addEventListener('click', function () {
        drawer.classList.add('open');
      });
      var cl = document.getElementById('sb-close');
      if (cl) cl.addEventListener('click', closeDrawer);
      var sc = document.getElementById('sb-scrim');
      if (sc) sc.addEventListener('click', closeDrawer);
      drawer.querySelectorAll('nav a').forEach(function (a) {
        a.addEventListener('click', closeDrawer);
      });
    }

    /* ---- flavor detail modal (sec-flavors) ---- */
    var secFlavors = document.querySelector('.sec.flavors');
    if (secFlavors) {
      var sectionId = secFlavors.getAttribute('data-section-id');
      var fgrid = document.getElementById('flavor-grid-' + sectionId);
      var fmodal = document.getElementById('flavor-modal-' + sectionId);
      var ftoggle = document.getElementById('flavor-toggle-' + sectionId);
      var opener = null;
      var closeTimer = null;

      if (fgrid && fmodal) {
        function openModal(card) {
          var detail = card.querySelector('.flavor-detail');
          if (!fmodal || !detail) return;
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
          var body = fmodal.querySelector('.fmbody');
          body.innerHTML = '';
          var img = card.querySelector('.flavor-photo');
          if (img) {
            var pic = img.cloneNode(false);
            pic.removeAttribute('loading');
            body.appendChild(pic);
          }
          var info = detail.cloneNode(true);
          info.removeAttribute('hidden');
          info.className = 'fmc';
          body.appendChild(info);
          var name = info.querySelector('h3');
          fmodal.setAttribute('aria-label', name ? name.textContent : '');
          var sw = window.innerWidth - document.documentElement.clientWidth;
          document.body.style.overflow = 'hidden';
          if (sw > 0) {
            document.body.style.paddingRight = sw + 'px';
            var hd = document.querySelector(
              '.sec-header-section, .shopify-section:has(> .header)',
            );
            if (hd) hd.style.paddingRight = sw + 'px';
          }
          fmodal.classList.add('open');
          void fmodal.offsetWidth;
          fmodal.classList.add('show');
          opener = card;
          var x = fmodal.querySelector('.fmx');
          if (x) x.focus();

          if (window.sbTrack) {
            var ftitle = card.querySelector('.flavor-title');
            window.sbTrack.push('view_flavor_detail', {
              flavor_code: ftitle ? ftitle.dataset.track || '' : '',
              detail_source: 'home',
            });
          }
        }

        function closeModal() {
          if (!fmodal || !fmodal.classList.contains('open') || closeTimer)
            return;
          fmodal.classList.remove('show');
          var reduce = window.matchMedia(
            '(prefers-reduced-motion: reduce)',
          ).matches;
          closeTimer = setTimeout(
            function () {
              closeTimer = null;
              fmodal.classList.remove('open');
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
              var hd = document.querySelector(
                '.sec-header-section, .shopify-section:has(> .header)',
              );
              if (hd) hd.style.paddingRight = '';
              if (opener) {
                opener.focus();
                opener = null;
              }
            },
            reduce ? 0 : 240,
          );
        }

        fgrid.addEventListener('click', function (e) {
          var card = e.target.closest('.flavor-card');
          if (card && fgrid.contains(card)) openModal(card);
        });
        fgrid.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var card = e.target.closest('.flavor-card');
          if (card && fgrid.contains(card)) {
            e.preventDefault();
            openModal(card);
          }
        });
        fmodal.addEventListener('click', function (e) {
          if (e.target.closest('[data-fm-close]')) closeModal();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeModal();
        });

        /* ---- nutrition facts expand / collapse (inside modal) ---- */
        fmodal.addEventListener('click', function (e) {
          var tg = e.target.closest('[data-fmn-toggle]');
          if (!tg || !fmodal.contains(tg)) return;
          var panel = fmodal.querySelector('[data-fmn-panel]');
          if (!panel) return;
          var expanded = tg.getAttribute('aria-expanded') !== 'true';
          tg.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (expanded) {
            var mbody = fmodal.querySelector('.fmbody');
            if (panel.parentElement !== mbody) mbody.appendChild(panel);
          }
          panel.hidden = !expanded;

          var zh =
            (expanded
              ? tg.getAttribute('data-less-zh')
              : tg.getAttribute('data-more-zh')) + (expanded ? ' −' : ' ＋');
          var en =
            (expanded
              ? tg.getAttribute('data-less-en')
              : tg.getAttribute('data-more-en')) + (expanded ? ' −' : ' ＋');
          tg.setAttribute('data-zh', zh);
          tg.setAttribute('data-en', en);
          var currentLang = localStorage.getItem('sb_lang') || 'zh';
          tg.textContent = currentLang === 'en' ? en : zh;
        });
      }

      /* ---- expand / collapse toggle ---- */
      if (fgrid && ftoggle) {
        var hiddenCards = fgrid.querySelectorAll('.flavor-card--hidden');
        if (hiddenCards.length === 0) {
          ftoggle.style.display = 'none';
        } else {
          var showMoreZh =
            ftoggle.getAttribute('data-show-more') || '查看全部口味';
          var showLessZh = ftoggle.getAttribute('data-show-less') || '收起';
          var showMoreEn =
            ftoggle.getAttribute('data-show-more-en') || 'View all flavors';
          var showLessEn =
            ftoggle.getAttribute('data-show-less-en') || 'Collapse';

          function updateToggleText(expanded) {
            var enText = expanded ? showLessEn : showMoreEn;
            var zhText = expanded ? showLessZh : showMoreZh;
            ftoggle.setAttribute('data-expanded', expanded ? 'true' : 'false');
            ftoggle.setAttribute('data-en', enText);
            ftoggle.setAttribute('data-zh', zhText);
            var currentLang = localStorage.getItem('sb_lang') || 'zh';
            ftoggle.textContent = currentLang === 'en' ? enText : zhText;
          }

          ftoggle.addEventListener('click', function () {
            var isExpanded = ftoggle.getAttribute('data-expanded') === 'true';
            if (isExpanded) {
              fgrid.classList.remove('flavor-grid--expanded');
              updateToggleText(false);
            } else {
              fgrid.classList.add('flavor-grid--expanded');
              updateToggleText(true);
            }
          });
        }
      }
    }

    seedAdCookies();
    trackHomepage();
    applyLang();
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init);
  else init();
})();
